import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import i18next from 'i18next';
import Row from 'react-bootstrap/Row';

import Background from '../../resources/assets/hero-home-oct-2020.jpeg';
import InputBox from '../../lib/InputBox';
import { PASSWORD_MAX_LENGTH, USERNAME_MAX_LENGTH } from '../../lib/password';

export default function LoginView(props) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState(''); 
  return (<>
    <Container style={{
      height: '500px',
      backgroundImage: `url(${Background})`,
      borderRadius: '3px' ,
      boxShadow: "0 0 8px 8px rgba(40, 44, 52, 0.7) inset"
      }}>
    <Row>
      <Col md={{ span: 5, offset: 7 }}>
        <InputBox>
          <Container >
            <Row className="justify-content-sm-right">
              <Form style={{ width: '100%', margin: '1em' }} onSubmit={event => {event.preventDefault(); props.onSubmit(username, password)}}>
                <Form.Group controlId="login">
                  <Form.Label>{i18next.t('login.username')}</Form.Label>
                  <Form.Control name="username" type="input" placeholder={i18next.t('login.username')} value={username} maxLength={USERNAME_MAX_LENGTH} onChange={event => setUsername(event.target.value)} autoFocus />
                </Form.Group>
                <Form.Group controlId="formBasicPassword">
                  <Form.Label>{i18next.t('login.password')}</Form.Label>
                  <Form.Control name="password" type="password" placeholder={i18next.t('login.password')} value={password} maxLength={PASSWORD_MAX_LENGTH} onChange={event => setPassword(event.target.value)} />
                </Form.Group>
                <Button name="sign-in" variant="primary" type="button" disabled={isDisabled()} onClick={() => props.onSubmit(username, password)}>
                  {i18next.t('login.signIn')}
                </Button>
                {!isDisabled() && <input type='submit' hidden tabIndex='-1' />}
                <p id="message">{props.message}</p>
              </Form>
            </Row>
         </Container>
       </InputBox>
     </Col>
   </Row>
 </Container>
</>);

  function isDisabled() {
    return !(Boolean(username) && Boolean(password));
  }
}